//@ts-nocheck
import { formatCurrency } from './currencyHelper';
import { getStoredCurrencyConfig } from './paymentDisplay';

export const getCheckoutPaymentMethodOrder = (
  methods,
  multiCurrencyEnabled
) => {
  if (
    !multiCurrencyEnabled ||
    !methods?.includes('card') ||
    !methods.includes('us_bank_account')
  )
    return methods;

  return ['card', ...methods.filter((method) => method !== 'card')];
};

export const formatCheckoutCharge = (selection, locale = 'en') => {
  if (!selection?.currency || !Number.isFinite(selection?.chargeAmount))
    return '';
  const currencyConfig = getStoredCurrencyConfig(selection.currency);
  if (!currencyConfig) return '';
  return formatCurrency(selection.chargeAmount, { ...currencyConfig, locale });
};
